<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.sysText.employeeSettings_header }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
  <mat-divider class="section-header-underline"></mat-divider>
</div>


<mat-dialog-content>
  <ng-container>
    <form [formGroup]="form">
      <div class="dialog--section">
        <mat-icon>check_circle</mat-icon><p class="grey1">{{ data.sysText.employeeSettings_allowAccess }}</p>
      </div>
      <div class="toggle--section">
        <app-slide-toggle
          [control]="allowAccess"
          [label]="data.sysText.employeeSettings_allowAccessDesc"
          [checked]="this.data.eeRecord.allowAccess"
        ></app-slide-toggle>
      </div>
      <p class="bottom-margin"></p>
      <div class="dialog--section">
        <mat-icon>check_circle</mat-icon><p class="grey1">{{ data.sysText.employeeSettings_allowNewLeaves }}</p>
      </div>
      <div class="toggle--section">
        <app-slide-toggle
          [control]="allowNewLeaves"
          [label]="data.sysText.employeeSettings_allowNewLeavesDesc"
          [checked]="this.data.eeRecord.allowNewLeaves"
        ></app-slide-toggle>
      </div>
    </form>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

